export default __webpack_public_path__ + "static/media/pronto.fe474e48.svg";